<template>
  <v-main
        class="fill-height container_bg content--text"
        id="mainContent"
        :style=img_bg_style
      >
      
    <v-item-group mandatory class="mt-n1">
      <v-container >
        <v-row justify="center" >
              <!-- cols="12" xs="10" sm="6" md="3"  -->
          <v-col cols="auto"               
                v-for="(item, i) in systemMenuList" :key="i">
            <v-item >              
                    <v-card class="mx-auto rounded-xl"
                          :color="i%2 == 0 ? '#FBE9E7' : '#B9F6CA'"
                          @click="goItem({code:item.pgmId, menu: item.ename, linkUrl: item.linkAddr, menuId:item.menuId, prtId:item.prtId}) "
                          flat       
                          outlined 
                          height="160"
                          width="150"
                    >
                    <v-row>
                      <v-col cols="12" sm="12">
                        <v-list-item three-line class="text-center">
                          <v-list-item-content>
                            <div align="center" >
                              <v-img
                                :src="item.imgButton"
                                height="65"
                                width="65"
                                contain
                              ></v-img>
                            </div>
                            <v-list-item-subtitle
                              class="caption mt-4"
                              ><span style="font-size: 11pt">  {{ item.ename }} </span>
                              </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                    </v-row>                   
                    </v-card>
            </v-item>                    
          </v-col>  
        </v-row>
      </v-container > 
    </v-item-group>  
  </v-main>
</template>

<script>


import { getSystemMenu } from '@/api/system/menuManage'
import { openMenu } from '@/api/system/userManage'

export default {
  name: "v10Menu",
  data: () => ({
    toggle_exclusive: 1,
    systemMenuList:[],
    dataInfo: null
  }),
  components: {
   
  },
  created() {
    // this.$store.dispatch("IsMenuName", this.msg);
    this.$emit("MenuName", {code:'main', name: 'Human-Resources'}); 
    // this.$emit("MenuName", obj.menu);
  },
  mounted() {    
    this.getSystemMenuList()
  },

  methods: {
    getSystemMenuList(){
      this.systemMenuList = []
      let param = {
        userId: this.$store.state.user.userId,
        sysCd: this.$store.state.system.sysCd,
      }
      getSystemMenu(param).then(res => {        
        this.systemMenuList = res.list
      })
    },

    goItem(obj) {            

       //-------------------Login History----------------------------
       let params = {

        menuId: obj.menuId,
        prtId: obj.prtId,
        jspNm: obj.menu + '(' + obj.code + ')',
        userId: this.$store.state.user.userId,
        } 

        openMenu(params).then(res => {    
          })

        //-------------------Login History----------------------------


      this.$emit("MenuName", {code:this.$store.state.system.sysCd, name: obj.menu}); 

      if(obj.code==''||obj.code == null){
        this.snackbar = true        
      }else{
        this.$router.push("/" + obj.code).catch(e => {
        this.vToastify(this.$t('View does not exist.'), 'warn')
        // if (!isNavigationFailure(e, NavigationFailureType.redirected))
        //   Promise.reject(e);
        });
      }

      
    },
  }
}  

</script>

<style>
  .app_bar_bg {
      border-radius: 0px;
      background: linear-gradient(90deg, #3df383 0%, #039233 100%);
      color: #ffffff !important;
      font-weight: bold;
      font-size: 18px !important;
  }
</style>